import React, { useEffect, useState } from 'react';
import { translate } from '../../../services/translate';
import { useQuery } from '@tanstack/react-query';
import { crmService } from '../../../services/central-api/crm';
import BasicModal from '../../../components/BasicModal';

interface Props {
    isModalVisible: boolean;
    setModalVisible: (value: boolean) => void;
    observation: string;
    reason?: TicketReason;
    formSubmit: () => Promise<void>;
    ticketId: number;
}

export default function EmailPreviewModal({ isModalVisible, setModalVisible, observation, reason, formSubmit, ticketId }: Props) {

    const [content, setContent] = useState('');

    const { data } = useQuery({
        queryKey: ['getCameraSlaTemplate', ticketId],
        queryFn: () => crmService.getCameraSlaTemplate(ticketId),
        enabled: !!ticketId,
    });


    useEffect(() => {
        if (isModalVisible && data) {
            setContent(data.htmlContent.replaceAll('{{observation}}', `O cenário DRP ${reason?.name} foi adicionado ao ticket #${ticketId}.<br>${observation.replaceAll('\n', '<br>')}`));
        }
    }, [isModalVisible, data]);

    return (
        <BasicModal
            isModalVisible={isModalVisible}
            setModalVisible={setModalVisible}
            title={translate('reviewEmailInfo')}
            width='large'
            primaryButton={{
                text: translate('send'),
                onClick: formSubmit,
            }}
        >
            <iframe
                title="Email preview"
                srcDoc={content}
                style={{
                    width: '100%',
                    height: '600px',
                    border: '1px solid #ddd',
                    borderRadius: 8,
                    background: '#fff',
                }}
            />

        </BasicModal>
    );
}
